import style from './Loader.module.scss';
export default function Loader() {
  return <div id="loader" className={style.root} data-sentry-component="Loader" data-sentry-source-file="Loader.tsx">
			<div data-testid="loader" className={style.loader}></div>
		</div>;
}